"use client";

import { initializeApp, getApp, getApps } from "firebase/app";
import type { ActionCodeSettings, User } from "firebase/auth";
import {
    getAuth,
    multiFactor,
    PhoneMultiFactorGenerator,
    signOut,
} from "firebase/auth";
import { publicEnv } from "@/lib/env";

// See: https://firebase.google.com/docs/web/learn-more#config-object
const firebaseConfig = () => ({
    appId: publicEnv("FIREBASE_APP_ID"),
    apiKey: publicEnv("FIREBASE_API_KEY"),
    projectId: publicEnv("FIREBASE_PROJECT_ID"),
});

export const getClientApp = () =>
    getApps().length ? getApp() : initializeApp(firebaseConfig());

export const firebaseApp = () => getClientApp();
export const firebaseAuth = () => getAuth(firebaseApp());

export const logout = () => signOut(firebaseAuth());
export const setSessionCookie = (token: string, remember = false) =>
    fetch("/api/login", {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: JSON.stringify({ remember }),
    });

export const hasMultiFactorAuth = (user: User) =>
    multiFactor(user).enrolledFactors.some(
        (factor) => factor.factorId === PhoneMultiFactorGenerator.FACTOR_ID,
    );

export const useActionCodeSettings = (): ActionCodeSettings => ({
    url: `${window.location.origin}/login`,
});
